<template>
	<div class="page" data-name="parent-agree">	
		<div class="page-content">
			<f7-navbar>
				<f7-nav-left>
					<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
				</f7-nav-left>
				<div class="title">
					본인 인증
				</div>					
				<f7-nav-right>
					<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
				</f7-nav-right>
    	</f7-navbar>

			<div class="block">회원가입을 진행 하기위해서 본인 인증을 진행 하셔야 합니다. </div>
				
		</div>
	</div>	
</template>
<script>
	import MODULE from '../../js/common/module.js'
	import Vue from 'vue';
	import { f7 } from 'framework7-vue';
	import CONST from '../../js/common/constant.js'
	import AUTH from '../../js/common/auth.js'
	import PAGES from '../../js/pages.js'
	import API from '../../js/common/api.js'

	export default {	
		data() {
			return {
				

			}		
		},
		mounted() {	
			const _this = this;		    
		},	
		methods: {	
			keyPress(event,type){
				const _this = this;
	
			},
			
		}		
	}
</script>
 

		